import { match, P } from 'ts-pattern';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuid } from 'uuid';

export function getNewSingleInstrumentationID(
	customSingleInstrumentationIDFromEvent: string | undefined,
	customSingleInstrumentationIDFromUserConfig: string | undefined,
): string {
	// priority for setting singleInstrumentationID override rule
	// 1. from consumer event attribute
	// 2. from consumer configuration
	// 3. from cookie lib
	// 4. default behaviour generates through the crypto API
	return (
		match({
			customSingleInstrumentationIDFromEvent,
			customSingleInstrumentationIDFromUserConfig,
		})
			.with(
				{ customSingleInstrumentationIDFromEvent: P.string },
				(result) => result.customSingleInstrumentationIDFromEvent,
			)
			.with(
				{ customSingleInstrumentationIDFromUserConfig: P.string },
				(result) => result.customSingleInstrumentationIDFromUserConfig,
			)
			// we can't use the crypto API in the browser due to SSR issues?
			// https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
			// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
			.otherwise(() => uuid())
	);
}
